import { render, staticRenderFns } from "./ai-chat-loader.vue?vue&type=template&id=f555c656&scoped=true"
import script from "./ai-chat-loader.vue?vue&type=script&lang=js"
export * from "./ai-chat-loader.vue?vue&type=script&lang=js"
import style0 from "./ai-chat-loader.vue?vue&type=style&index=0&id=f555c656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f555c656",
  null
  
)

export default component.exports